export type DriverOperation = { id: number; name: string; svcIds: number[] };

type ScopeLike = {
  operations: { id: number; name: string }[];
  svcs: { id: number; operationId: number }[];
};

/**
 * Operaciones que tienen al menos un SVC del chofer, por nombre. Un SVC cuya
 * operación no vino en el scope (cache vieja) igual genera la suya, como
 * "Operación {id}", para no dejarlo fuera del fan-out.
 */
export const getDriverOperations = (scope: ScopeLike): DriverOperation[] => {
  const byId = new Map<number, DriverOperation>();
  for (const svc of scope.svcs) {
    const op = byId.get(svc.operationId);
    if (op) {
      op.svcIds.push(svc.id);
      continue;
    }
    const name = scope.operations.find((o) => o.id === svc.operationId)?.name ?? `Operación ${svc.operationId}`;
    byId.set(svc.operationId, { id: svc.operationId, name, svcIds: [svc.id] });
  }
  return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name, "es"));
};

export const isMultiOperation = (ops: DriverOperation[]): boolean => ops.length > 1;

export const operationNamesOf = (ops: DriverOperation[]): Map<number, string> =>
  new Map(ops.map((o) => [o.id, o.name]));
